export const EventBusEvents = {
    "OPEN_VERIFY_FLOW": "0",
    "OPEN_SUPPORT_MODAL": "1",
    "SHOW_NOTIFICATION": "2",
    "OPEN_SHARE_MODAL": "3",
    "OPEN_COUPON_MODAL": "4",
    "OPEN_MENU_TIME_MODAL": "5"
  }